<template>
  <div>
    <div v-if="loading">
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </div>
    <v-card v-if="newsData != null">
      <v-card-title>Edit news</v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" v-model="isValid">
          <v-text-field
            filled
            label="News title"
            v-bind:rules="validation.title"
            v-model="newsData.title"
            @change="onTitleChange($event)"
          ></v-text-field>
          <redactor v-model="newsData.body"></redactor>

          <br />
          <v-autocomplete
            filled
            required
            autocomplete="off"
            label="Select Category"
            v-model="newsData.category_id"
            :rules="validation.category"
            item-text="name"
            item-value="id"
            v-bind:items="category"
          ></v-autocomplete>
          <v-card class="my-2">
            <v-card-title>
              Add tag (optional)
            </v-card-title>
            <v-card-text>
              <v-combobox
                v-model="newsData.content_tag"
                chips
                outlined
                clearable
                label="Add tag and press enter"
                multiple
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    aria-multiline="true"
                    @click="select"
                    @click:close="removeContentTag(item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-card-text>
          </v-card>
          <v-card>
            <v-card-title>
              Images
            </v-card-title>
            <v-file-input
              filled
              class="pa-4"
              label="Browse"
              accept="image/*"
              prepend-icon="mdi-camera"
              v-model="imageData"
              @change="imageInputChangedCallback"
              multiple
            >
              <template v-slot:selection> </template>
            </v-file-input>
            <div
              v-if="
                selectedImages !== null &&
                  Array.isArray(selectedImages) &&
                  selectedImages.length > 0
              "
            >
              <file-images
                :images="selectedImages"
                @delete_success="offlineImageDeleteCallback"
              />
            </div>
            <div
              v-if="
                serverImages !== null &&
                  Array.isArray(serverImages) &&
                  serverImages.length > 0
              "
            >
              <v-container fluid grid-list-md tile>
                <v-layout row wrap>
                  <v-flex
                    xs12
                    md6
                    v-for="item in serverImages ? serverImages : []"
                    :key="item.id"
                  >
                    <image-card
                      :image="item"
                      :id="item.id"
                      @delete_success="callbackImgDeleteSuccess"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
            <v-card-subtitle v-else>No uploaded Image</v-card-subtitle>
          </v-card>
          <br />

          <v-card>
            <v-card-title>
              Body Image
            </v-card-title>
            <v-file-input
              filled
              class="pa-4"
              label="Browse"
              accept="image/*"
              prepend-icon="mdi-image-album"
              hide-details
              @change="bodyImageInputChangedCallback"
            >
              <template v-slot:selection> </template>
            </v-file-input>
            <div
              v-if="
                selectedBodyImages !== null &&
                  Array.isArray(selectedBodyImages) &&
                  selectedBodyImages.length > 0
              "
            >
              <file-images
                :images="selectedBodyImages"
                @delete_success="offlineBodyImageDeleteCallback"
              />
            </div>
            <div
              v-if="
                serverBodyImages !== null &&
                  Array.isArray(serverBodyImages) &&
                  serverBodyImages.length > 0
              "
            >
              <v-container fluid grid-list-md tile>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <image-card
                      :image="serverBodyImages[0]"
                      :id="serverBodyImages[0].id"
                      @delete_success="callbackImgDeleteSuccess"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
            <v-card-subtitle v-else>No uploaded Image</v-card-subtitle>
          </v-card>
          <br />
          <v-text-field
            label="Select publish date"
            solo
            clearable
            readonly
            :rules="validation.publishDate"
            v-model="formattedDate"
            @click:clear="dateClearCallback"
            prepend-icon="mdi-calendar"
            @click="showDatePicker"
          ></v-text-field>
          <v-checkbox
            label="Check for headline"
            v-model="newsData.is_headline"
          />
          <v-checkbox
            label="For Subscriber only"
            v-model="newsData.is_for_subscriber"
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          tile
          color="primary"
          class="mx-2"
          :disabled="!isValid"
          v-on:click="update"
          v-bind:loading="this.loading"
          >Update</v-btn
        >
        <v-spacer />
      </v-card-actions>
    </v-card>
    <DatePickerDialog
      @dateSelected="dateSelectionCallback"
      :visible="showDatePickerDialog"
      @close="showDatePickerDialog = false"
    ></DatePickerDialog>
  </div>
</template>
<script>
import snackbar from '@/utils/snackbar'
import urlUtils from '@/utils/urlUtils'
import postApi from '@/api/postApi'
import dateUtils from '@/utils/dateUtils'
import DatePickerDialog from '@/components/DatePickerDialog'
import * as dateFormats from '@/constants/dateFormats'
import commonUtils from '@/utils/commonUtils'
import redactor from '@/components/Redactor.vue'

export default {
  components: {
    'image-card': () => import('@/components/ImageDeleteCard'),
    DatePickerDialog,
    'file-images': () => import('@/components/ImagesFromFiles'),
    redactor
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      isValid: null,
      loading: false,
      serverImages: [],
      imageData: null,
      serverBodyImages: [],
      selectedImages: [],
      selectedBodyImages: [],
      formattedDate: null,
      showDatePickerDialog: false,
      category: null,
      tempBody: '',
      tempData: {
        title: '',
        body: null,
        is_headline: null,
        publish_date: null,
        guest_writer_id: null,
        is_for_subscriber: null,
        category_id: null
      },
      validation: {
        title: [v => !!v || 'Please enter title'],
        category: [v => !!v || 'Please select category'],
        publishDate: [v => !!v || 'Please enter publish date']
      },

      newsData: {
        content_tag: [],
        id: null,
        title: null,
        body: '',
        is_headline: null,
        new_images: [],
        body_image: null,
        publish_date: null,
        guest_writer_id: null,
        images: [],
        is_for_subscriber: null,
        category_id: null
      }
    }
  },

  computed: {},
  beforeRouteLeave (to, from, next) {
    this.$log.info('Before route leave check equality', [
      this.tempData.title,
      this.newsData.title,
      this.tempData.title !== this.newsData.title
    ])
    this.$log.info('Before route leave', [
      this.dataChanged(),
      this.selectedImages,
      this.selectedBodyImages
    ])
    if (
      !this.loading &&
      (this.dataChanged() ||
        this.selectedImages.length > 0 ||
        this.selectedBodyImages.length > 0)
    ) {
      const answer = window.confirm(
        'Do you really want to leave? you have unsaved changes!'
      )
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  watch: {
    'newsData.title': function (newVal, oldVal) {
      this.$log.info('title ', [newVal, oldVal])
      if (newVal && newVal[newVal.length - 1] === '\\') {
        this.newsData.title = oldVal !== null ? oldVal + 'ṭ' : 'ṭ'
      } else if (newVal && newVal[newVal.length - 1] === '|') {
        this.newsData.title = oldVal !== null ? oldVal + 'Ṭ' : 'Ṭ'
      }
    }
  },
  methods: {
    removeContentTag (item) {
      this.newsData.content_tag.splice(
        this.newsData.content_tag.indexOf(item),
        1
      )
    },
    dataChanged () {
      // return this.tempData.is_headline !== this.newsData.is_headline

      return this.tempData.title !== this.newsData.title ||
        this.tempData.body === null
        ? false
        : this.tempData.body !== this.newsData.body ||
            this.tempData.category_id !== this.newsData.category_id ||
            this.tempData.publish_date !== this.formattedDate ||
            this.tempData.is_headline !== this.newsData.is_headline ||
            this.tempData.is_for_subscriber !== this.newsData.is_for_subscriber
    },
    offlineBodyImageDeleteCallback (data) {
      const index = this.selectedBodyImages.indexOf(data.file)
      if (index !== undefined && index !== null) {
        if (index > -1) {
          this.selectedBodyImages.splice(index, 1)
        }
      }
    },
    offlineImageDeleteCallback (data) {
      // clear file input
      this.imageData = null

      const index = this.selectedImages.indexOf(data.file)
      if (index !== undefined && index !== null) {
        if (index > -1) {
          this.selectedImages.splice(index, 1)
        }
      }
    },
    async bodyImageInputChangedCallback (file) {
      this.newsData.body_image = file

      if (file == null) {
        // this.selectedImages = []
        return
      }

      const reader = new FileReader()
      reader.onload = e => this.selectedBodyImages.push(e.target.result)
      reader.readAsDataURL(file)
    },
    async imageInputChangedCallback (file) {
      if (file == null) {
        // this.selectedImages = []
        return
      }

      file.forEach(element => {
        this.newsData.new_images.push(element)
        const reader = new FileReader()
        reader.onload = e => this.selectedImages.push(e.target.result)
        reader.readAsDataURL(element)
      })
    },
    dateClearCallback () {
      this.$log.info('date clear callback')
      this.newsData.publish_date = null
    },
    dateSelectionCallback (data) {
      this.$log.info('date selection callback', [data])
      this.formattedDate = data
      this.newsData.publish_date = dateUtils.parseDate(data)
    },
    showDatePicker () {
      this.showDatePickerDialog = true
    },
    async init () {
      await this.fetchCategory()
      await this.getNewsById()
    },
    callbackImgDeleteSuccess () {
      this.$log.info('Image delete callback')
      this.getNewsById()
    },
    getImageFullUrl (url) {
      var k = urlUtils.getImageUrl(url)
      return k
    },
    async update () {
      this.$log.info('udpating news params', [this.newsData])
      if (this.newsData.body === '') {
        snackbar.show('Please enter body', 'error')
        return
      }
      this.newsData.images = this.newsData.new_images
      this.newsData.new_images = []
      this.selectedImages = []
      this.selectedBodyImages = []
      if (this.newsData.content_tag) {
        this.newsData.tag = this.newsData.content_tag.join(' § ')
      }
      try {
        this.loading = true
        await postApi.updateNews(this.newsData)
        snackbar.show('News updated successfully', 'success')
        window.publish_date = this.newsData.publish_date

        this.$router.push({ path: '/news', replace: true })
      } finally {
        this.loading = false
      }
    },
    async getNewsById () {
      this.loading = true
      try {
        const response = await postApi.getNewsById(this.$route.params.id)
        if (response.data !== undefined) {
          this.assignValues(response.data)
        }
      } finally {
        this.loading = false
      }
    },
    async fetchCategory () {
      this.loading = true
      const k = await postApi.getCategories()
      if (k.data !== undefined) {
        this.category = k.data
      }
    },
    assignValues (data) {
      this.newsData.id = data.id
      this.newsData.title = data.title
      this.newsData.body = data.body
      this.newsData.is_for_subscriber = data.is_for_subscriber
      this.newsData.is_headline = data.is_headline
      this.$log.info('assign values is_headline', [data.is_for_subscriber])
      this.serverBodyImages = data.body_image

      this.newsData.category_id = data.category.id
      this.serverImages = data.images
      this.newsData.publish_date = data.publish_date
      this.formattedDate = this.$moment(this.newsData.publish_date).format(
        dateFormats.DDMMYY
      )
      if (data.tag) {
        this.newsData.content_tag = data.tag.split(' § ')
        this.$log.info('content tag', [this.newsData.content_tag])
      }
      if (
        data.guest_writer !== undefined &&
        Array.isArray(data.guest_writer) &&
        data.guest_writer.length > 0
      ) {
        this.newsData.guest_writer_id = data.guest_writer[0].id
      }
      this.assignTempData()
    },
    assignTempData () {
      this.tempData.title = this.newsData.title
      this.tempData.is_for_subscriber = this.newsData.is_for_subscriber
      this.tempData.is_headline = this.newsData.is_headline
      this.tempData.category_id = this.newsData.category_id
      this.tempData.publish_date = this.formattedDate
    },
    onTitleChange (newVal, oldVal) {
      this.$log.info('Ontitle change', newVal, oldVal)
      this.newsData.title = commonUtils.parseStringForTri(newVal)
    }
  }
}
</script>

<style>
.ql-editor {
  min-height: 350px;
  font-size: 15px;
}
</style>
